import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import MyDialog from '@/components/MyDialog.vue';
import MySelect from '@/components/MySelect.vue';
let ValueEditor = class ValueEditor extends Vue {
    constructor() {
        super(...arguments);
        this.isOpen = false;
        this.modifierAmount = 0;
        this.modifierType = 'Add';
    }
    get newValue() {
        return {
            Add: this.value + this.modifierAmount,
            Subtract: Math.max(0, this.value - this.modifierAmount),
            Set: Math.max(0, this.modifierAmount)
        }[this.modifierType];
    }
    resetValues() {
        this.modifierAmount = 0;
        this.modifierType = 'Add';
    }
    applyChanges() {
        this.isOpen = false;
        this.$emit('input', this.newValue);
    }
};
__decorate([
    Prop(Number)
], ValueEditor.prototype, "value", void 0);
__decorate([
    Prop(String)
], ValueEditor.prototype, "label", void 0);
ValueEditor = __decorate([
    Component({
        components: {
            MyDialog,
            MySelect
        }
    })
], ValueEditor);
export default ValueEditor;
